import { ZfLoadingSpinner } from '@zafire/react';
import type { FunctionComponent, PropsWithChildren } from 'react';
import { useMemo } from 'react';
import { useConfiguration } from '../../api/configuration';
import { appEnvironmentContext } from './app-environment-context';
import { LocalStore } from './app-environment-local-store';

export const AppEnvironmentProvider: FunctionComponent<PropsWithChildren> = ({ children }) => {
    const { data: configuration } = useConfiguration();
    const localStore = useMemo(() => new LocalStore(), []);

    if (!configuration) return <ZfLoadingSpinner style={{ margin: 'auto' }} />;

    return <appEnvironmentContext.Provider value={{ ...configuration, localStore }}>{children}</appEnvironmentContext.Provider>;
};
